import { render, staticRenderFns } from "./UnitItems.vue?vue&type=template&id=272cf5ea"
import script from "./UnitItems.vue?vue&type=script&lang=js"
export * from "./UnitItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports